/**
 * 加载页面组件，可支持懒加载
 * @param {String} component
 */
const getComponent = component => {
    return resolve => {
        () =>
        import (`@/components/${component}.vue`).then(module => {
            resolve(module);
        });
    };
};

// const getview = component => {
//   return resolve => {
//    () => import(`@/views/${component}.vue`).then(module => {
//       resolve(module);
//     });
//   };pushchannelmanage
// };
const getSviews = component => {
    return resolve => {
            () =>
            import (`@/views/${component}.vue`).then(module => {
                resolve(module);
            });
        }
        // return resolve => require([`@/views/${component}.vue`], resolve)
}

//特殊路由
// const home = resolve => require(["../../views/layout/Index.vue"], resolve);
// const home2 = resolve => require(["../../views/Router.vue"], resolve);

//() => import Home from '../../views/Home.vue'

import config from '../../../app.config'

/* 登录*/
const login = {
    path: "/",
    component: () =>
        import ("@/views/login/Index.vue"),
    meta: {
        title: '登录-' + config.appTitle
    }
};
const loginNoToken = {
    path: "/loginNoToken",
    component: () =>
        import ("@/views/login/Index.vue"),
    meta: {
        title: '登录-' + config.appTitle
    }
};
//单点登录
const eastnetLogin = {
    path: '/sso/eastnet/login',
    name: 'eastnetLogin',
    component: () =>
        import ("@/views/easyLogin/easyLogin.vue"),

    meta: {
        title: '登录-' + config.appTitle
    }
};

const seeAltas = {
    path: '/seeAltas',
    name: '/seeAltas',
    // component:() => import("@/views/contributor/piccenter/piccenter/piccenter.vue"),
    component: () =>
        import ("@/views/contributor/piccenter/photocenter/mineAltas.vue"),

    meta: {
        title: '图集'
    }
};

// const test = 
//   {
//     path: '/',
//     name: 'Home',
//     component: Home
//   }
//   const test1 = 
//   {
//     path: '/about',
//     name: 'About',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () =>() => import(/* webpackChunkName: "about" */ '../../views/About.vue')
//   }



//下载
const Upload = [{
        path: '/',
        name: 'mobileUpdate',
        component: () =>
            import ("@/views/mobileupload/nopic/nopic.vue"),
        meta: {
            title: '手机上传'
        }
    },
    {
        path: '/mobileAtlas',
        name: 'mobileAtlas',
        component: () =>
            import ("@/views/mobileAtlas/mobileAtlas.vue"),
        meta: {
            title: '手机上传'
        }
    },
    {
        path: '/mobileUpdate',
        name: 'mobileUpdate',
        component: () =>
            import ("@/views/mobileupload/nopic/nopic.vue"),
        meta: {
            title: '手机上传'
        }
    },
    {
        path: '/timeout',
        name: 'timeout',
        component: () =>
            import ("@/views/mobileupload/timeout/timeout.vue"),
        meta: {
            title: '手机上传'
        }
    },
    {
        path: '/uploadbj',
        name: 'uploadbj',
        component: () =>
            import ("@/views/mobileupload/uploadbj/uploadbj.vue"),
        meta: {
            title: '手机上传'
        },
        children: [{
                path: '/',
                name: 'uploader',
                component: () =>
                    import ("@/views/mobileupload/uploader/uploader.vue"),
                meta: {
                    title: '手机上传'
                }
            },
            {
                path: '/uploader',
                name: 'uploader',
                component: () =>
                    import ("@/views/mobileupload/uploader/uploader.vue"),
                meta: {
                    title: '手机上传'
                }
            },
            {
                path: '/save',
                name: 'save',
                component: () =>
                    import ("@/views/mobileupload/save/save.vue"),
                meta: {
                    title: '手机上传'
                }
            },
            {
                path: '/progress',
                name: 'progress',
                component: () =>
                    import ("@/views/mobileupload/progress/progress.vue"),
                meta: {
                    title: '手机上传'
                }
            },
            {
                path: '/uploadprocess',
                name: 'uploadprocess',
                component: () =>
                    import ("@/views/mobileupload/uploadprocess/uploadprocess.vue"),
                meta: {
                    title: '手机上传'
                }
            },
        ]
    },


]


//移动端页面
const mobileworkflow = {
    path: '/mobileWorkflow/check',
    name: 'check',
    component: () =>
        import ("@/views/mobileworkflow/check/check.vue"),
    meta: {
        title: '复审投稿图片'
    }
}

//移动端页面
const containermobile = {
    path: '/public/mobileUpdate',
    name: 'public',
    component: () =>
        import ("@/views/mobileupload/mobileUpdate/mobileUpdate.vue"),
    children: Upload
}





//投稿人路由
const contributor = [

    // 工作桌面
    {
        path: '/',
        name: 'desktopContributor',
        component: () =>
            import ("@/views/contributor/house/house.vue"),

        meta: {
            title: '工作桌面-' + config.appTitle,
            field: 'desktopAuthor',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/desktop/contributor',
        name: 'desktopContributor',
        component: () =>
            import ("@/views/contributor/house/house.vue"),

        meta: {
            title: '工作桌面-' + config.appTitle,
            field: 'desktopAuthor',
            requireAuth: true,
            keepAlive: false
        }
    },

    // 用搞人工作桌面
    {
        path: '/desktop/editor',
        name: 'desktopEditor',
        component: () =>
            import ("@/views/user/house/house.vue"),

        meta: {
            title: '工作桌面-' + config.appTitle,
            field: 'desktopEditor',
            requireAuth: true,
            keepAlive: false
        }
    },

    // 管理者工作桌面
    {
        path: '/desktop/manager',
        name: 'desktopManager',
        component: () =>
            import ("@/views/manage/house/house.vue"),

        meta: {
            title: '工作桌面-' + config.appTitle,
            field: 'desktopManager',
            requireAuth: true,
            keepAlive: false
        }
    },

    //个人图库
    {
        path: '/myLib/myAtlas',
        name: 'personpicindex',
        component: () =>
            import ("@/views/contributor/personpic/index.vue"),

        meta: {
            title: '个人图库-' + config.appTitle,
            field: 'allowMyGallery',
            requireAuth: true,
            keepAlive: true
        },
        children: [{
                path: '/',
                name: 'personpic',
                component: () =>
                    import ("@/views/contributor/personpic/personpic/personpic.vue"),

                meta: {
                    title: '个人图库-' + config.appTitle,
                    field: 'allowMyGallery',
                    requireAuth: true,
                    keepAlive: true
                }
            },
            {
                path: '/myLib/unClutteredPicture',
                name: 'myLibUnClutteredPicture',
                component: () =>
                    import ("@/views/contributor/personpic/nnclutteredPic/nnclutteredPic.vue"),

                meta: {
                    title: '未整理图片-' + config.appTitle,
                    field: 'browseUnPicture',
                    requireAuth: true,
                    keepAlive: false
                }
            },
            {
                path: '/myLib/peopleManage',
                name: 'myLibPeopleManage',
                component: () =>
                    import ("@/views/contributor/personpic/peoplemanage/peoplemanage.vue"),

                meta: {
                    title: '图片人物管理-' + config.appTitle,
                    field: 'myFace',
                    requireAuth: true,
                    keepAlive: false
                }
            },
            {
                path: '/myLib/seepersonface',
                name: 'myLibSeepersonface',
                component: () =>
                    import ("@/views/contributor/personpic/seepersonface/seepersonface.vue"),

                meta: {
                    title: '查看人物图片-' + config.appTitle,
                    field: 'myFace',
                    requireAuth: true,
                    keepAlive: false
                }
            },
            {
                path: '/personpic',
                name: 'personpic',
                component: () =>
                    import ("@/views/contributor/personpic/personpic/personpic.vue"),

                meta: {
                    title: '个人图库-' + config.appTitle,
                    field: 'allowMyGallery',
                    requireAuth: true,
                    keepAlive: true
                }
            },
            {
                path: '/myLib/myPic',
                name: '/myLibMyPic',
                component: () =>
                    import ("@/views/contributor/personpic/minepic/minepic.vue"),

                meta: {
                    title: '我的图片-' + config.appTitle,
                    field: 'allowMyGallery',
                    requireAuth: true,
                    keepAlive: false
                }
            },
            {
                path: '/myLib/myVideo',
                name: '/myLibMyVideo',
                component: () =>
                    import ("@/views/contributor/personpic/minevideo/minevideo.vue"),

                meta: {
                    title: '我的视频-' + config.appTitle,
                    field: 'allowMyGallery',
                    requireAuth: true,
                    keepAlive: false
                }
            },
            {
                path: '/myLib/myWord',
                name: '/myLibMyWord',
                component: () =>
                    import ("@/views/contributor/personpic/mineword/mineword.vue"),

                meta: {
                    title: '我的文稿-' + config.appTitle,
                    field: 'allowMyGallery',
                    requireAuth: true,
                    keepAlive: false
                }
            },
            {
                path: '/myLib/show',
                name: 'myLibShow',
                component: () =>
                    import ("@/views/contributor/personpic/piclist/piclist.vue"),

                meta: {
                    title: '图片列表-' + config.appTitle,
                    field: 'myAtlas',
                    requireAuth: true,
                    keepAlive: false
                }
            },
            {
                path: '/shareAndPush/show',
                name: 'shareAndPushShow',
                component: () =>
                    import ("@/views/contributor/personpic/sharepiclist/sharepiclist.vue"),

                meta: {
                    title: '图片列表-' + config.appTitle,
                    requireAuth: true,
                    keepAlive: false
                }
            },

            {
                path: '/pictureUpload',
                name: 'pictureUpload',
                component: () =>
                    import ("@/views/contributor/personpic/picupload/picupload.vue"),

                meta: {
                    title: '图片上传-' + config.appTitle,
                    field: 'createAtlas',
                    requireAuth: true,
                    keepAlive: false
                }
            },
        ]
    },


    //图片中心
    {
        path: '/pictureCenter',
        name: '/pictureCenter',
        // component:() => import("@/views/contributor/piccenter/piccenter/piccenter.vue"),
        component: () =>
            import ("@/views/contributor/piccenter/photocenter/photocenter.vue"),

        meta: {
            title: '媒资检索-' + config.appTitle,
            field: 'allowGalleryCenter',
            requireAuth: true,
            keepAlive: true
        }
    },
    {
        path: '/addword',
        name: '/addword',
        // component:() => import("@/views/contributor/piccenter/piccenter/piccenter.vue"),
        component: () =>
            import ("@/views/contributor/piccenter/addword/addword.vue"),

        meta: {
            title: '创建文稿-' + config.appTitle,
            field: 'allowGalleryCenter',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/pictureCenter/atlas/show',
        name: 'pictureCenterAtlasShow',
        component: () =>
            import ("@/views/contributor/piccenter/picbrowse/picbrowse.vue"),

        meta: {
            title: '图片浏览-' + config.appTitle,
            field: 'allowGalleryCenter',
            requireAuth: true,
            keepAlive: false
        }
    },


    //分享与推送
    {
        path: '/shareAndPush/myShare',
        name: 'shareAndPushMyShare',
        component: () =>
            import ("@/views/contributor/share/myshare/myshare.vue"),

        meta: {
            title: '我的分享-' + config.appTitle,
            field: 'browseShare',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/shareAndPush/myPush',
        name: 'shareAndPushMyPush',
        component: () =>
            import ("@/views/contributor/share/mypush/mypush.vue"),

        meta: {
            title: '我的推送-' + config.appTitle,
            field: 'browsePush',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/shareAndPush/pushToMe',
        name: 'shareAndPushToMe',
        component: () =>
            import ("@/views/contributor/share/pushtome/pushtome.vue"),

        meta: {
            title: '推送给我-' + config.appTitle,
            field: 'browsePush',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/shareAndPush/seeWork',
        name: 'shareAndPushSeeWork',
        component: () =>
            import ("@/views/contributor/share/seeworkgroup/seeworkgroup.vue"),

        meta: {
            title: '浏览工作圈-' + config.appTitle,
            field: 'browseShare',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/shareAndPush/myDownload',
        name: 'shareAndPushMyDownload',
        component: () =>
            import ("@/views/contributor/share/mydownload/mydownload.vue"),

        meta: {
            title: '我的下载-' + config.appTitle,
            field: 'browseDownload',
            requireAuth: true,
            keepAlive: false
        }
    },

    {
        path: '/shareAndPush/push/qms',
        name: 'shareAndPushPushQms',
        component: () =>
            import ("@/views/contributor/share/allpush/allpush.vue"),

        meta: {
            title: '推送至:全媒体-' + config.appTitle,
            field: 'picturePush',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/shareAndPush/push/mcp',
        name: 'shareAndPushPushMcp',
        component: () =>
            import ("@/views/contributor/share/fusepush/fusepush.vue"),

        meta: {
            title: '推送至:融媒体-' + config.appTitle,
            field: 'picturePush',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/shareAndPush/push/show',
        name: 'shareAndPushPushShow',
        component: () =>
            import ("@/views/contributor/share/showpush/showpush.vue"),

        meta: {
            title: '推送至:展示网站-' + config.appTitle,
            field: 'picturePush',
            requireAuth: true,
            keepAlive: false
        }
    },
    //征稿活动
    {
        path: '/pictureActivity/manage',
        name: 'pictureActivityManage',
        component: () =>
            import ("@/views/contributor/draftactivity/draftactivitymanage/draftactivitymanage.vue"),

        meta: {
            title: '征稿活动管理-' + config.appTitle,
            field: 'allowGather',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/pictureLive/manage',
        name: 'pictureLiveManage',
        component: () =>
            import ("@/views/contributor/draftactivity/livepicmanage/livepicmanage.vue"),

        meta: {
            title: '图片直播管理-' + config.appTitle,
            field: 'allowGather',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/pictureLive/livePic',
        name: 'pictureLiveLivepic',
        component: () =>
            import ("@/views/contributor/draftactivity/livepic/livepic.vue"),

        meta: {
            title: '图片直播筛选-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/pictureNeed/manage',
        name: 'pictureNeedManage',
        component: () =>
            import ("@/views/contributor/draftactivity/picinvitemanage/picinvitemanage.vue"),

        meta: {
            title: '图片邀约管理-' + config.appTitle,
            field: 'allowGather',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/desktop/myPictureNeed',
        name: 'desktopMyPictureNeed',
        component: () =>
            import ("@/views/contributor/draftactivity/mypicinvite/mypicinvite.vue"),

        meta: {
            title: '我的邀约-' + config.appTitle,
            field: 'appointPictureNeed',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/workflow/listPictureActivityArticle',
        name: 'workflowListPictureActivityArticle',
        component: () =>
            import ("@/views/contributor/draftactivity/solicitationactivities/solicitationactivities.vue"),

        meta: {
            title: '征稿活动-' + config.appTitle,
            field: 'checkPictureArticle',
            requireAuth: true,
            keepAlive: true
        }
    },
    {
        path: '/pictureNeed/show',
        name: 'pictureNeedShow',
        component: () =>
            import ("@/views/contributor/draftactivity/picinviteseepic/picinviteseepic.vue"),

        meta: {
            title: '查看图片包-' + config.appTitle,
            field: 'allowGather',
            requireAuth: true,
            keepAlive: false
        }
    },

    //工作流
    {
        path: '/workflow/userAuth',
        name: 'workflowUserAuth',
        component: () =>
            import ("@/views/contributor/workflow/userauth/userauth.vue"),

        meta: {
            title: '用户认证-' + config.appTitle,
            field: 'checkUserAuthInfo',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/tabs',
        name: 'tabs',
        component: () =>
            import ("@/views/contributor/workflow/tabs/tabs.vue"),

        meta: {
            title: '选项卡-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/shu',
        name: 'shu',
        component: () =>
            import ("@/views/contributor/workflow/shu/shu.vue"),

        meta: {
            title: '竖-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/workflow/activityChoose',
        name: 'workflowActivityChoose',
        component: () =>
            import ("@/views/contributor/workflow/activitycontribution/activitycontribution.vue"),

        meta: {
            title: '活动征稿-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/workflow/columnCheck',
        name: 'workflowColumnCheck',
        component: () =>
            import ("@/views/contributor/workflow/columnCheck/columnCheck.vue"),

        meta: {
            title: '栏目征稿-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: true
        }
    },
    {
        path: '/workflow/picChoose',
        name: 'workflowPicChoose',
        component: () =>
            import ("@/views/contributor/workflow/piccontribution/piccontribution.vue"),

        meta: {
            title: '图片展示-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },

    {
        path: '/workflow/listTask',
        name: 'workflowListTask',
        component: () =>
            import ("@/views/contributor/workflow/subpicmanager/subpicmanager.vue"),

        meta: {
            title: '投稿图片筛选列表-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/workflow/picShow',
        name: 'workflowPicShow',
        component: () =>
            import ("@/views/contributor/workflow/picshow/picshow.vue"),

        meta: {
            title: '图片展示列表-' + config.appTitle,
            field: 'browseWebsiteInfo',
            requireAuth: true,
            keepAlive: true
        }
    },
    {
        path: '/workflow/rotationSet',
        name: 'workflowRotationSet',
        component: () =>
            import ("@/views/contributor/workflow/rotationset/rotationset.vue"),

        meta: {
            title: '轮播图设置-' + config.appTitle,
            field: 'browseWebsiteCarousel',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/workflow/screenPic',
        name: 'workflowScreenpic',
        component: () =>
            import ("@/views/contributor/workflow/screenpic/screenpic.vue"),

        meta: {
            title: '投稿图片筛选-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/heng',
        name: 'heng',
        component: () =>
            import ("@/views/contributor/workflow/heng/heng.vue"),

        meta: {
            title: '横-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },

    {
        path: '/config/labelManage',
        name: 'configLabelManage',
        component: () =>
            import ("@/views/contributor/setup/labelmanage/labelmanage.vue"),

        meta: {
            title: '标签管理-' + config.appTitle,
            field: 'customLabelConfig',
            requireAuth: true,
            keepAlive: false
        }
    },

    {
        path: '/config/classificationManage',
        name: 'configClassificationManage',
        component: () =>
            import ("@/views/contributor/setup/classificationmanage/classificationmanage.vue"),

        meta: {
            title: '标签分类管理-' + config.appTitle,
            field: 'customLabelClassConfig',
            requireAuth: true,
            keepAlive: false
        }
    },

    {
        path: '/config/picManage',
        name: 'configPicManage',
        component: () =>
            import ("@/views/contributor/setup/picmanage/picmanage.vue"),

        meta: {
            title: '图库管理-' + config.appTitle,
            field: 'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/config/roleManage',
        name: 'configRoleManage',
        component: () =>
            import ("@/views/contributor/setup/rolemanage/rolemanage.vue"),

        meta: {
            title: '角色管理-' + config.appTitle,
            field: 'roleConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/config/userManage',
        name: 'configUserManage',
        component: () =>
            import ("@/views/contributor/setup/usermanage/usermanage.vue"),

        meta: {
            title: '用户管理-' + config.appTitle,
            field: 'userConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/config/workGroup',
        name: 'configWorkGroup',
        component: () =>
            import ("@/views/contributor/setup/worksetupmanage/worksetupmanage.vue"),

        meta: {
            title: '工作圈管理-' + config.appTitle,
            field: 'justAdmin',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/config/activityThemeManage',
        name: 'configActivityThemeManage',
        component: () =>
            import ("@/views/contributor/setup/activitythememanage/activitythememanage.vue"),

        meta: {
            title: '活动主题管理-' + config.appTitle,
            field: 'activityThemeConfig',
            requireAuth: true,
            keepAlive: false
        }
    },


    {
        path: '/config/appTextConfigManage',
        name: 'configAppTextConfigManage',
        component: () =>
            import ("@/views/contributor/setup/textagreementmanage/textagreementmanage.vue"),

        meta: {
            title: '文本与协议管理-' + config.appTitle,
            field: 'textConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/config/basic',
        name: 'contributorbasicsetup',
        component: () =>
            import ("@/views/contributor/setup/basicssetup/basicssetup.vue"),

        meta: {
            title: '基础设置-' + config.appTitle,
            field: 'baseConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/config/oneLogin',
        name: 'configOneLogin',
        component: () =>
            import ("@/views/contributor/setup/oneloginmanage/oneloginmanage.vue"),

        meta: {
            title: '单点登录配置-' + config.appTitle,
            field: 'ssoConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/config/safey',
        name: 'configsafey',
        component: () =>
            import ("@/views/contributor/setup/safemanage/safemanage.vue"),

        meta: {
            title: '安全配置-' + config.appTitle,
            field: 'securityConfig',
            requireAuth: true,
            keepAlive: false
        }
    },

    {
        path: '/config/site',
        name: 'configsite',
        component: () =>
            import ("@/views/contributor/setup/sitemanage/sitemanage.vue"),

        meta: {
            title: '站点配置-' + config.appTitle,
            field: 'websiteConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    // {
    //     path: '/contributorpersonsetup',
    //     name: 'contributorpersonsetup',
    //     component:() => import("@/views/contributor/setup/personsetup/personsetup.vue"),

    //     meta: {
    //         title: '个人设置-' + config.appTitle,
    //         field: 'desktopAuthor',
    //         requireAuth: true,
    //         keepAlive: false
    //     }
    // },
    // {
    //     path: '/contributorsetup',
    //     name: 'contributorsetup',
    //     component:() => import("@/views/contributor/setup/userandpswsetup/userandpswsetup.vue"),

    //     meta: {
    //         title: '账号密码-' + config.appTitle,
    //         field: 'desktopAuthor',
    //         requireAuth: true,
    //         keepAlive: false
    //     }
    // },
    {
        path: '/recyclebin/pic',
        name: 'recyclebinPic',
        component: () =>
            import ("@/views/contributor/recyclebin/recyclePic/recyclePic.vue"),

        meta: {
            title: '图片回收站-' + config.appTitle,
            field: 'allowRecycleBin',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/recyclebin/video',
        name: 'recyclebinVideo',
        component: () =>
            import ("@/views/contributor/recyclebin/recycleVideo/recycleVideo.vue"),

        meta: {
            title: '视频回收站-' + config.appTitle,
            field: 'allowRecycleBin',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/recyclebin/word',
        name: 'recyclebinWord',
        component: () =>
            import ("@/views/contributor/recyclebin/recycleWord/recycleWord.vue"),

        meta: {
            title: '文稿回收站-' + config.appTitle,
            field: 'allowRecycleBin',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/config/pushChannelManage',
        name: 'pushchannelmanage',
        component: () =>
            import ("@/views/contributor/setup/pushchannelmanage/pushchannelmanage.vue"),

        meta: {
            title: '推送渠道管理-' + config.appTitle,
            field: 'pushConfig',
            requireAuth: true,
            keepAlive: false
        }
    },

    // 下载日志记录
    {
        path: '/digitalCenter/downloadLog',
        name: 'downloadLog',
        component: () =>
            import ("@/views/contributor/digitalcenter/downloadLog/downloadLog.vue"),

        meta: {
            title: '下载日志记录-' + config.appTitle,
            field:'resourceLogCenter',
            requireAuth: true,
            keepAlive: false
        }
    },

    // 智能节点管理
    {
        path: '/digitalCenter/smartCenter',
        name: 'smartCenter',
        component: () =>
            import ("@/views/contributor/digitalcenter/smartcenter/smartcenter.vue"),

        meta: {
            title: '智能节点管理-' + config.appTitle,
            // field:'setup',
            requireAuth: true,
            keepAlive: false
        }
    },
    // 数据分析
    {
        path: '/digitalCenter/dataAnalysis',
        name: 'dataAnalysis',
        component: () =>
            import ("@/views/contributor/digitalcenter/dataanalysis/dataanalysis.vue"),

        meta: {
            title: '数据分析-' + config.appTitle,
            // field:'setup',
            requireAuth: true,
            keepAlive: false
        }
    },


    //系统设置
    {
        path: '/config/platform',
        name: 'configPlatform',
        component: () =>
            import ("@/views/contributor/operationmanage/platform/platform.vue"),

        meta: {
            title: '平台运维-' + config.appTitle,
            // field:'libConfig',
            requireAuth: true,
            keepAlive: false
        }
    },
    {
        path: '/config/journalManage',
        name: 'configJournalManage',
        component: () =>
            import ("@/views/contributor/operationmanage/journalmanage/journalmanage.vue"),

        meta: {
            title: '系统日志-' + config.appTitle,
            // field: 'systemLogs',
            requireAuth: true,
            keepAlive: false
        }
    },
    // 共享盘管理
    {
        path: '/operationManage/shareManage',
        name: 'shareManage',
        component: () =>
            import ("@/views/contributor/operationmanage/sharemanage/sharemanage.vue"),

        meta: {
            title: '共享盘管理-' + config.appTitle,
            // field:'setup',
            requireAuth: true,
            keepAlive: false
        }
    },

    // 第三方接入
    {
        path: '/operationManage/thirdAccess',
        name: 'thirdAccess',
        component: () =>
            import ("@/views/contributor/operationmanage/thirdaccess/thirdaccess.vue"),
        meta: {
            title: '第三方接入-' + config.appTitle,
            // field:'setup',
            requireAuth: true,
            keepAlive: false
        }
    },
    // 回调管理
    {
        path: '/operationManage/callBack',
        name: 'callBack',
        component: () =>
            import ("@/views/contributor/operationmanage/callbackmanage/callbackmanage.vue"),
        meta: {
            title: '回调管理-' + config.appTitle,
            // field:'setup',
            requireAuth: true,
            keepAlive: false
        }
    },
]

//管理者路由
// const manage = [
//   // 管理者工作桌面
//   {
//     path: '/manage',
//     name: 'manage',
//     component:() => import("@/views/manage/house/house.vue"),
//     meta:{
//       title:'管理工作桌面',
//       requireAuth: true
//     }
//   },
// ]

//用搞人路由
// const user = [
//   // 用搞人工作桌面
//   {
//     path: '/user',
//     name: 'user',
//     component:() => import("@/views/user/house/house.vue"),
//     meta:{
//       title:'用搞工作桌面',
//       requireAuth: true
//     }
//   },
// ]

const container = {
        path: '/container',
        name: 'container',
        component: () =>
            import ("@/views/layout/container.vue"),
        children: contributor
    }
    /* 个人中心*/
    // const personal = {
    //   path: "/personal",
    //   meta: {
    //     title: "个人中心"
    //   },
    //   component: home,
    //   children: [
    //     {
    //       path: "account",
    //       meta: {
    //         title: "账号信息"
    //       },
    //       component: getComponent("personal/account/Index")
    //     },
    //     {
    //       path: "security",
    //       meta: {
    //         title: "安全设置"
    //       },
    //       // component: resolve => require(['../views/personal/security/Index.vue'], resolve)
    //       component: getComponent("personal/security/Index")
    //     }
    //   ]
    // };
    /* 首次登录重置密码 */
    // const updatePassword = {
    //   path: "updatePassword",
    //   component: getComponent("login/Upload")
    // };
const mobilePageChildren = []
const mobilePage = {
    path: '/pictureCenterMobile',
    name: 'pictureCenterMobile',
    component: () =>
        import ("@/views/mobilePage/pictureCenterMobile.vue"),
    children: mobilePageChildren
}
export default [
    // {
    //   path: "/",
    //   // name: "index",
    //   component: home,
    //   redirect: "login",
    //   children: []
    // },
    // {
    //   path: "/layout",
    //   name: "index",
    //   component: home,
    //   // redirect: "metadata",
    //   children: [updatePassword]
    // },
    login,
    seeAltas,
    loginNoToken,
    eastnetLogin,
    container,
    containermobile,
    mobileworkflow,
    mobilePage,
    {
        path: "*",
        name: "404",
        component: () =>
            import ("@/views/error/404.vue"),
        meta: {
            title: '错误页面-' + config.appTitle
        }
    },
    {
        path: "/404",
        name: "404",
        component: () =>
            import ("@/views/error/404.vue"),
        meta: {
            title: '错误页面-' + config.appTitle
        }
    },
    {
        path: "/login",
        name: 'login',
        component: () =>
            import ("@/views/login/Index.vue"),
        meta: {
            title: '登录-' + config.appTitle
        }
    },
    {
        path: "/refresh",
        name: 'refresh',
        component: () =>
            import ("@/views/changerouter/refresh.vue"),
        meta: {
            title: '登录-' + config.appTitle
        }
    },
    {
        path: "/renewal",
        name: 'renewal',
        component: () =>
            import ("@/views/renewal/renewal.vue"),
        meta: {
            title: '系统更新-' + config.appTitle
        }
    },
    {
        path: "/versionChange",
        name: 'versionChange',
        component: () =>
            import ("@/views/versionChange/versionChange.vue"),
        meta: {
            title: '更新内容-' + config.appTitle
        }
    }
    /* {
          path: "*",
          redirect: "/404"
      } */
];